// App.js
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
  createRoutesFromElements,
  Route,
  ScrollRestoration,
  Navigate,
  useParams,
  useLocation,
} from "react-router-dom";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Home from "../src/Pages/Home/Home";
import { ToastContainer } from "react-toastify";
import About from "./Pages/About/About";
import Contact from "./Pages/Contact/Contact";
import Products from "./Pages/Products/Products";
import Blogs from "./Pages/Blogs/Blogs";
import ProductDetail from "./Pages/ProductDetail/ProductDetail";
import BlogDetail from "./Pages/BlogDetail/BlogDetail";
import Kampaniya from "./Pages/Kampaniya/Kampaniya";
import AboveHeader from "./Components/AboveHeader/AboveHeader";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { I18nextProvider } from "react-i18next";
import i18n from "./Components/i18n/i18n";
import Thanks from "./Pages/Thanks/Thanks";
import { avatar } from "./assets/images";
import Login from "./Pages/Login/Login";
import Register from "./Pages/Register/Register";
import Cart from "./Pages/Cart/Cart";
import Favourites from "./Pages/Favourites/Favourites";
import Locations from "./Pages/Locations/Locations";
import Orders from "./Pages/Orders/Orders";
import Completed from "./Pages/Completed/Completed";
import Comments from "./Pages/Comments/Comments";
import Privacy from "./Pages/Privacy/Privacy";
import Profile from "./Pages/Profile/Profile";
import axios from "axios";
import Success from "./Pages/Success/Success";
import Error from "./Pages/Error/Error";

const LanguageWrapper = ({ children }) => {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const location = useLocation(); // Əlavə edildi

  useEffect(() => {
    const changeLanguage = async () => {
      if (["az", "en", "ru"].includes(lang)) {
        await i18n.changeLanguage(lang);
      } else {
        await i18n.changeLanguage("az");
      }
    };

    changeLanguage();
  }, [lang, location.pathname]); // Yalnız lang və pathname'i izlə

  return children;
};
const Layout = () => {
  return (
    <div>
      <ToastContainer position="top-right" autoClose={1000} theme="colored" />
      <AboveHeader />
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route path="/" element={<Navigate to="/az" replace />} />

      <Route
        path="/:lang"
        element={
          <LanguageWrapper>
            <Layout />
          </LanguageWrapper>
        }
      >
        <Route index element={<Home />} />
        <Route path="about" element={<About />} />
        <Route path="privacy" element={<Privacy />} />
        <Route path="products" element={<Products />} />
        <Route path="product-detail/:id" element={<ProductDetail />} />
        <Route path="blogs" element={<Blogs />} />
        <Route path="blogs/:id" element={<BlogDetail />} />
        <Route path="kampaniya" element={<Kampaniya />} />
        <Route path="contact" element={<Contact />} />
        <Route path="contact/thank-you" element={<Thanks />} />
        <Route path="orders/thank-you" element={<Thanks />} />
        <Route path="login" element={<Login />} />
        <Route path="register" element={<Register />} />
        <Route path="cart" element={<Cart />} />
        <Route path="profile" element={<Profile />} />
        <Route path="favourites" element={<Favourites />} />
        <Route path="locations" element={<Locations />} />
        <Route path="orders" element={<Orders />} />
        <Route path="completed" element={<Completed />} />
        <Route path="comments" element={<Comments />} />

        <Route path="success" element={<Success />} />
        <Route path="error" element={<Error />} />
        {/* <Route path="payment" element={<PaymentButton />} /> */}
      </Route>
    </Route>
  )
);

function App() {
  const [settings, setSettings] = useState([]);

  useEffect(() => {
    getSettings();
  }, []);

  async function getSettings() {
    try {
      // API'den verileri çekiyoruz
      const response = await axios.get(
        "https://www.elzabeauty.az/elza/settings.php"
      );
      setSettings(response.data.data[0]); // Gelen veriyi state'e kaydediyoruz
    } catch (error) {
      console.error("Error fetching categories:", error); // Hata durumunda mesaj yazdırıyoruz
    }
  }

  return (
    <div className="font-secondFont bg-[#F4F4F4]">
      <I18nextProvider i18n={i18n}>
        <RouterProvider router={router}>
          <ScrollRestoration />
        </RouterProvider>
      </I18nextProvider>

      <FloatingWhatsApp
        phoneNumber={settings.whatsappNumber}
        accountName="Elza Beauty"
        chatMessage="Salam, sizə necə kömək edə bilərik?"
        placeholder="Mesaj yazın..."
        avatar={avatar}
        messageDelay="1"
      />
    </div>
  );
}

export default App;
